<template>
  <body>
  <div class="container">
    <!--顶部卡片-->
    <div id="card">
      <div id="scrolling-message">
<!--        <div class="message">-->
<!--          <span class="houTaiManage">HP-C系统是针对水泵和风机的节能系统。通过昊邦物联网后台实时监测、解析现场数据，再进行数据拆分修正运算。在确保工艺环境不变的情况下，指挥矢量执行器实时按需供给冷热量，从而达到最佳的节能效果。</span>-->
<!--        </div>-->
      </div>
      <div>
        <el-dropdown style="position: absolute;right:50px;top: 20px;color: white;cursor: pointer;">
             <span class="el-dropdown-link">
               {{user.user_name}}<i class="el-icon-user"></i><i class="el-icon-arrow-down el-icon--right"></i>
             </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><router-link to="/menu/updatePassword">修改密码</router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/">退出登录</router-link></el-dropdown-item>
            <el-dropdown-item>建议反馈</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!--卡片二-->
    <div id="card1">
      <div>
        <span style="font-size: 15px">欢迎您</span>
        <span style="color: rgb(16,163,127);font-size: 15px">{{user.user_name}},</span>
        <span style="font-size: 15px">祝您今天过的开心!</span>
      </div>
    </div>
    <!--左侧动态菜单-->
    <div class="el-tac">
      <el-row class="tac" style="flex-grow: 1;">
        <el-col :span="24">
          <div style="display: flex;justify-content: center;align-items: center;">
            <h3 class="h3">
              <button class="icon-hope" style="border: none; cursor: pointer;" />
              <span style="font-size: 15px">HPC节能系统</span>
            </h3>
          </div>
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            style="background-color: rgb(53,61,68); flex-grow: 1;">
            <el-menu-item index="1" @click="homepage" v-if="user.is_staff === '0'">
              <i class="el-icon-office-building"></i>
              <span slot="title">项目列表</span>
            </el-menu-item>
            <el-menu-item index="2" @click="userAll" v-if="user.is_staff === '0'">
              <i class="el-icon-office-building"></i>
              <span slot="title">企业管理</span>
            </el-menu-item>
            <el-menu-item index="3" @click="userNewHome" v-if="user.is_staff === '1'">
              <i class="el-icon-menu"></i>
              <span slot="title">系统主页</span>
            </el-menu-item>
            <el-menu-item
              :class="{'disabled-menu-item': user.is_staff === '1'}"
              @click.native.prevent="handleDisabledClick"
              v-if="user.is_staff === '0' || user.is_staff === '1'"
              :style="{ pointerEvents: user.is_staff === '1' ? 'none' : 'auto' }"
            >
              <i class="el-icon-menu"></i>
              <span slot="title">接入设备</span>
            </el-menu-item>
            <el-submenu
              :class="{'disabled-submenu-item': user.is_staff === '1'}"
              index="5"
              v-if="user.is_staff === '0' || user.is_staff === '1'"
              :style="{ pointerEvents: user.is_staff === '1' ? 'none' : 'auto' }"
            >
              <template slot="title">
                <i class="el-icon-s-data"></i>
<!--                <span style="color: rgb(214,215,217)">数据中心</span>-->
                <span style="color: rgb(214,215,217)">数据中心</span>
              </template>
<!--              @click.native.prevent="handleDisabledClick"-->
              <el-menu-item
                :class="{'disabled-menu-item': user.is_staff === '1'}"
                index="6"
                v-if="user.is_staff === '0' || user.is_staff === '1'"
              >
                <i class="el-icon-magic-stick"></i>
                <span slot="title" style="color: rgb(53,61,68)">碳排放</span>
              </el-menu-item>
<!--              @click.native.prevent="handleDisabledClick"-->
              <el-menu-item
                @click="AllEquEnergy"
                :class="{'disabled-menu-item': user.is_staff === '1'}"
                index="7"
                v-if="user.is_staff === '0' || user.is_staff === '1'"
              >
                <i class="el-icon-document"></i>
                <span slot="title" style="color: rgb(53,61,68)">节能统计</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              :class="{'disabled-menu-item': user.is_staff === '1'}"
              @click.native.prevent="handleDisabledClick"
              index="8"
              v-if="user.is_staff === '0' || user.is_staff === '1'"
              :style="{ pointerEvents: user.is_staff === '1' ? 'none' : 'auto' }"
            >
              <i class="el-icon-menu"></i>
              <span slot="title">权限菜单</span>
            </el-menu-item>
            <el-menu-item
              :class="{'disabled-menu-item': user.is_staff === '1'}"
              @click="zhihui"
              index="9"
              v-if="user.is_staff === '0' || user.is_staff === '1'"
              :style="{ pointerEvents: user.is_staff === '1' ? 'none' : 'auto' }"
            >
              <i class="el-icon-menu"></i>
              <span slot="title">智慧大屏</span>
            </el-menu-item>
            <el-menu-item index="10" @click="deviceList()" v-if="user.is_staff === '1'">
              <i class="el-icon-setting"></i>
              <span slot="title">设备列表</span>
            </el-menu-item>
            <el-menu-item index="11" @click="test" v-if="user.is_staff === '2'">
              <i class="el-icon-setting"></i>
              <span slot="title">这是一个测试账号</span>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </div>

    <!--路由渲染位置-->
    <div class="ssss">
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </div>
  </div>
  </body>
</template>

<script>
export default {
  data() {
    return {
      user: {},
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
  },
  methods:{
    AllEquEnergy(){
      this.$router.push('/menu/allEquTable');
    },
    handleDisabledClick(event) {
      // 阻止默认点击行为
      event.stopPropagation();
      alert('此菜单项不可用');
    },
    zhihui() {
      this.$router.push('/menu/screen');
    },
    deviceList(){
      if (this.$router.currentRoute.path !== '/menu/card' && this.user.is_staff === '0') {
        this.$router.push('/menu/card')
      }else if (this.user.is_staff === '1'){
        //点击的时候回跟根据id去查
        this.$router.push({path:'/menu/userCard',query:this.user.com_id})
      }
    },
    goToReport() {
      this.$router.push('/menu/echarts');
    },
    userAll(){
      this.$router.push('/menu/table').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    carbonEmission(){

    },
    EnergySavingStatistics(){

    },
    none(){
      this.$router.push('/menu/none');
    },
    homepage(){
      this.$router.push('/menu/home').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    userNewHome(){
      this.$router.push('/menu/userNewHome').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    test(){
      if (this.$router.currentRoute.path !== '/menu/testHome') {
        this.$router.push('/menu/testHome');
      }
    },
  },
}
</script>

<style scoped>
.disabled-menu-item,
.disabled-submenu-item .el-submenu__title {
  color: gray !important; /* 设置为灰色 */
  cursor: not-allowed !important; /* 设置鼠标样式为不可点击 */
}

#scrolling-message {
  width: 90%; /* 消息容器宽度 */
  overflow: hidden; /* 隐藏超出容器的内容 */
}

/* 固定左侧菜单栏 */
.el-tac {
  position: fixed;
  top: 55px;
  left: 0;
  width: 14%;
  color: grey;
  background-color: rgb(53,61,68);
  height: calc(100vh - 50px); /* 固定菜单高度 */
  display: flex;
  flex-direction: column;
  z-index: 1002;
}

/* 调整主内容区域，使其不与菜单重叠 */
.ssss {
  margin-left: 14%; /* 使内容区向右偏移，避免与固定的菜单重叠 */
  padding-top: 120px; /* 留出顶部卡片的空间 */
  overflow: auto; /* 允许内容滚动 */
  height: calc(100vh - 120px); /* 内容区域高度为视口高度减去顶部卡片的高度 */
}

#card1 {
  position: fixed; /* 固定顶部卡片二 */
  top: 55px;
  left: 0;
  width: 100%;
  background-color: rgb(115,192,222);
  line-height: 50px;
  z-index: 1001; /* 确保在主内容上方 */
}

#card {
  height: 55px;
  background-color: grey;
  position: fixed; /* 固定顶部卡片一 */
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1002; /* 确保在所有元素的最上方 */
}

.h3 {
  background-color: rgb(53,61,68);
  padding: 38px;
  width: 145px;
}

.el-menu-vertical-demo {
  background-color: rgb(53,61,68);
  padding-right: 5px;
}

.el-menu-vertical-demo .el-menu-item,
.el-menu-vertical-demo .el-submenu__title {
  color: rgb(214,215,217);
}

.icon-hope {
  position: relative;
  top: 4px;
  background-image: url("../assets/img/img_2.png");
  background-size: 30px;
  background-color: rgb(53,61,68);
  background-repeat: no-repeat;
  display: inline-block;
  border: none;
  height: 30px;
  width: 30px;
}

a {
  text-decoration: none;
  color: rgba(96,91,102);
}

/*.houTaiManage {*/
/*  color: rgb(214,215,217);*/
/*  font-size: 30px;*/
/*}*/

.el-menu {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Menu.vue